require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/_core').Number.isFinite;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-finite.js
// module id = 146
// module chunks = 0